import React, { Component, PropTypes } from 'react';
import { setPasswordRequest } from 'common/ducks/user';
import { SubmissionError } from 'redux-form';
import ChangePasswordForm from 'account/components/change_password_form';

/**
 * Component used to update a user's password.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class ChangePassword extends Component {
  constructor(props) {
    super(props)
    this.state = {toggled: false}
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleToggle = this.handleToggle.bind(this)
  }

  handleSubmit(formData) {
    const { user, noConfirmation } = this.props
    const data = {no_confirmation: noConfirmation, ...formData}
    return setPasswordRequest(user.profile_data.id, data)
      .then(this.handleToggle)
      .catch((res) => {
        const data = res.data;

        /* field-specific errors */
        if (data) {
          for (const field of Object.keys(data)) {
            if (data[field]) {
              throw new SubmissionError({ [field]: data[field][0] })
            }
          }
        }

        throw new SubmissionError({ _error: 'Unknown error. Please try again.' });
      });
  }

  handleToggle() {
    this.setState({toggled: !this.state.toggled})
  }

  render() {
    return (
      <ChangePasswordForm onSubmit={this.handleSubmit} toggled={this.state.toggled}
        onToggle={this.handleToggle} noConfirmation={this.props.noConfirmation}/>
    )
  }
}

/**
 * PropTypes.
 *
 * @property {object} user - logged in user
 * @property {bool} noConfirmation - whether old password should be confirmed
 */
ChangePassword.propTypes = {
  user: PropTypes.object,
  noConfirmation: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./account/components/change_password.jsx